import { Component, Input, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { NgScrollbar } from 'ngx-scrollbar';
import { NgClass } from '@angular/common';
import { GeneralSidebarHeaderComponent } from '../../general-sidebar-header/general-sidebar-header.component';
import { InteractionBarStateService } from '../../../services/interaction-bar-state.service';

import { DayjsFormatterPipe } from '../../../pipes/framework/dayjs-formatter.pipe';
import { SimpleButtonComponent } from '../../buttons/simple-medium-button/simple-button.component';
import { MoneyPipe } from '../../../pipes/framework/money-short.pipe';
import { AdjustmentLog, AdjustmentLogByDate } from './budget-adjustment-log.interfaces';
import { BudgetAdjustment } from '@app/pages/webapp/projects/view-project/spend/project-budget-history/project-budget-history.types';

@Component({
  selector: 'app-budget-adjustment-log',
  templateUrl: './budget-adjustment-log.component.html',
  styleUrls: ['./budget-adjustment-log.component.scss'],
  imports: [
    GeneralSidebarHeaderComponent,
    NgScrollbar,
    NgClass,
    DayjsFormatterPipe,
    SimpleButtonComponent,
    MoneyPipe,
  ],
})
export class BudgetAdjustmentLogComponent implements OnInit {
  private _adjustments: BudgetAdjustment[];
  @Input() set adjustments(value: BudgetAdjustment[]) {
    this._adjustments = value;
    this.logs = this.getAdjustmentLogs();
    this.groupByDate();
    this.sortGroupedLogs();
  }
  get adjustments() {
    return this._adjustments;
  }

  groupLogDate: AdjustmentLogByDate[] = [];
  logs: AdjustmentLog[] = [];

  constructor(private interactionBar: InteractionBarStateService) {}

  ngOnInit(): void {}

  /**
   * Extract unique budget adjustment logs from project spend data.
   * Each spend data contains a list of budget adjustments.
   * Budget adjustments may contain duplicates across different line items.
   * Filters out duplicates by log ID.
   */
  getAdjustmentLogs() {
    const seenIds = new Set<number>();

    return this.adjustments
      .filter((adjustment) => {
        if (!seenIds.has(adjustment.id)) {
          seenIds.add(adjustment.id);
          return true;
        }
        return false;
      })
      .map((adjustment) => ({
        ...adjustment,
        deleted_at: null,
      }));
  }

  /**
   * <p>this function groups each budget adjustment log by the date it is created </p>
   * <p>note: it takes into consideration the current timezone. </p>
   * <p>Ex: an adjustment created on 15 Jun, 02:00 in UTC will be 14 Jun in California (PDT)</p>
   *
   */
  private groupByDate() {
    this.groupLogDate = this.logs.reduce((groupedLogs, log) => {
      const logDate = dayjs(log.created_at).utc().local().format('YYYY-MM-DD');
      const dateGroup = groupedLogs.find((groupLog) => groupLog.date === logDate);

      if (dateGroup) {
        // push log to existing date group
        dateGroup.logs.push(log);
      } else {
        // create new date group entry
        groupedLogs.push({
          date: logDate,
          logs: [log],
        });
      }

      return groupedLogs;
    }, []);
  }

  /**
   * sort by date in descending order the grouped logs
   *
   */
  private sortGroupedLogs() {
    this.groupLogDate.sort((a, b) => {
      return dayjs(a.date).isAfter(b.date) ? -1 : +1;
    });
  }

  close() {
    this.interactionBar.close();
  }
}
